import {EventEmitter} from 'eventemitter3'

export const generalPractitionerEvent = new EventEmitter()

export const generalPractitionerEventTypes = {
    TABLE_CHANGE: 'TABLE_CHANGE',
}

export function getGeneralPractitionerEventKey(eventType) {
    if (!eventType) {
        return ''
    }

    switch (eventType) {
        case generalPractitionerEventTypes.TABLE_CHANGE:
            return `GP_TABLE_CHANGE`
        default:
            return ''
    }
}

//#region TABLE CHANGE
export function onGeneralPractitionerTableChangeListener(
    eventType = generalPractitionerEventTypes.TABLE_CHANGE,
    data,
) {
    generalPractitionerEvent.emit(
        getGeneralPractitionerEventKey(eventType),
        data,
    )
}

export function onGeneralPractitionerTableChangeRemoveListener(
    eventType = generalPractitionerEventTypes.TABLE_CHANGE,
) {
    generalPractitionerEvent.removeListener(
        getGeneralPractitionerEventKey(eventType),
    )
}
//#endregion
